module.exports = __webpack_public_path__ + "img/18.e96e413b.png";